import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProductData from "./ProductData";
import { fetchProducts, filterProductsApi } from "./features/productSlice";

function ViewMore() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const types = searchParams.get("types");
  const category = searchParams.get("category");
  const dispatch = useDispatch();
  const {
    bestSellerProducts,
    arrivalProducts,
    popularProducts,
    filteredProducts,
    specialityProducts,
  } = useSelector((state) => state.product);
  const user = useSelector((state) => state.auth.user);
  const [isLoading, setIsLoading] = useState(true);
  // Get category name from the first filtered product (since all products in the category will have the same category name)
  const categoryName = filteredProducts?.[0]?.category?.categoryName || "";


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    window.scrollTo(0, 0);

    if (types) {
      dispatch(filterProductsApi({ location: types }));
    } else if (category) {
      dispatch(filterProductsApi({ category }));
    } else {
      dispatch(fetchProducts());
    }
    
    // Ensure loader shows for at least 0.4 seconds
    setTimeout(() => {
      setIsLoading(false);
    }, 600);
  }, [dispatch, types, category]);

  const totalProductCount =
    (specialityProducts?.length || 0) + (filteredProducts?.length || 0);

  if (isLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }
  return (
    <>
      <section className="banner-innr">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="banner-innr-content">
                <h3 style={{ color: "#3c3260" }}>
                  {" "}
                  {types || categoryName || "View All"}
                </h3>
                {(types || category) && (
                  <h6 className="text-center">
                    {filteredProducts?.length === 0 &&
                      specialityProducts?.length === 0
                      ? "(0 product)"
                      : `(${totalProductCount} Product${totalProductCount === 1 ? "" : "s"
                      })`}
                  </h6>
                )}
                {type === "arrivals" && (
                  <h6 className="text-center">
                    {arrivalProducts?.length === 0
                      ? "No new arrivals"
                      : `( ${arrivalProducts?.length}) Product${arrivalProducts?.length === 1 ? "" : "s"
                      }`}
                  </h6>
                )}
                {type === "bestsellers" && (
                  <h6 className="text-center">
                    {bestSellerProducts?.length === 0
                      ? "No bestsellers available"
                      : `( ${bestSellerProducts?.length} Product${bestSellerProducts?.length === 1 ? "" : "s"
                      })`}
                  </h6>
                )}
                {type === "popular" && (
                  <h6 className="text-center">
                    {popularProducts?.length === 0
                      ? "No popular products available"
                      : `(${popularProducts?.length} Product${popularProducts?.length === 1 ? "" : "s"
                      })`}
                  </h6>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tp-space shop-sec">
        <div className="container">
          {types && specialityProducts && specialityProducts.length > 0 && (
            <>
              <div className="heading justify-content-center mb-4">
                <h3 className="title">
                  State <span>Specialities</span>
                </h3>
              </div>
              <div className="row mb-5">
                {specialityProducts.map((product) => (
                  <ProductData
                    key={product._id}
                    product={product}
                    user={user}
                  />
                ))}
              </div>
            </>
          )}

          {types && filteredProducts && filteredProducts.length > 0 && (
            <>
              <div className="heading justify-content-center mb-4">
                <h3 className="title">
                  All <span style={{ color: "#3c3260" }}>Products</span>
                </h3>
              </div>
              <div className="row">
                {filteredProducts.map((product) => (
                  <ProductData
                    key={product._id}
                    product={product}
                    user={user}
                  />
                ))}
              </div>
            </>
          )}

          {category && filteredProducts && filteredProducts.length > 0 && (
            <>
              <div className="row">
                {filteredProducts.map((product) => (
                  <ProductData
                    key={product._id}
                    product={product}
                    user={user}
                  />
                ))}
              </div>
            </>
          )}

          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="row">
                {type === "arrivals" &&
                  (arrivalProducts && arrivalProducts.length > 0 ? (
                    arrivalProducts.map((product) => (
                      <ProductData
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))
                  ) : (
                    <div>No products available.</div>
                  ))}
                {type === "bestsellers" &&
                  (bestSellerProducts && bestSellerProducts.length > 0 ? (
                    bestSellerProducts.map((product) => (
                      <ProductData
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))
                  ) : (
                    <div>No products available.</div>
                  ))}
                {type === "popular" &&
                  (popularProducts && popularProducts.length > 0 ? (
                    popularProducts.map((product) => (
                      <ProductData
                        key={product._id}
                        product={product}
                        user={user}
                      />
                    ))
                  ) : (
                    <div>No products available.</div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ViewMore;
